import {IndicatorEditForm} from './components/indicator-edit-form';

export const CreateIndicator = () => {
  return <IndicatorEditForm action="create" />;
};
